export default "__VITE_ASSET__4d9b3e3d__"